/**
 * Einladungslink: tritt mit dem Code aus der URL bei und springt in die Lobby. Die manuelle
 * Code-Eingabe lebt auf dem Einstieg (/playtest).
 */
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Swords } from 'lucide-react';
import Page from '../../../ui/Page';
import EmptyState from '../../../ui/EmptyState';
import Skeleton from '../../../ui/Skeleton';
import { apiClient } from '../../../api/apiClient';
import { errorMessage } from '../../../api/errorMessage';

export default function JoinPlaytestPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;
    apiClient.post('/api/playtest/join', { inviteCode: (code || '').trim().toUpperCase() })
      .then((resp) => navigate(`/playtest/lobby/${resp.data.sessionId}`, { replace: true }))
      .catch((err) => setError(err));
  }, [code, navigate]);

  if (error) {
    return (
      <Page>
        <EmptyState
          variant="error"
          icon={Swords}
          title={errorMessage(error, 'Beitritt nicht möglich.')}
          action={<button type="button" className="btn-primary" onClick={() => navigate('/playtest')}>Zum Einstieg</button>}
        />
      </Page>
    );
  }
  return (
    <Page>
      <Skeleton width="240px" height="1.5em" />
      <p style={{ color: 'var(--text-secondary)' }}>Trete dem Playtest bei …</p>
    </Page>
  );
}
